import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchSchedule({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_schedule/fetch_container_scheduled_service/${container_scheduled_service_id}`
    );
  },
  fetchAgroExporter({ container_scheduled_service_id }) {
    return RequesterV1.get(
      `service_provider/services/container_op/edit_schedule/fetch_agro_exporter/${container_scheduled_service_id}`
    );
  },
  update({ container_scheduled_service_id, scheduled_at, started_at, finished_at, status_id, observations, service_templates }) {
    return RequesterV1.patch(
      `service_provider/services/container_op/edit_schedule/update/${container_scheduled_service_id}`,
      {
        container_scheduled_service: {
          scheduled_at,
          started_at,
          finished_at,
          status_id,
          observations,
        },
        service_templates
      }
    );
  },
};
